import { BasicStyledComponent } from 'shared-definitions/types'
import styles from './CommentsCount.module.css'
import clsx from 'clsx'
import Comment from 'shared-svg/CommentHollow.svg'
import CommentHubCommentsCounter from '../comments/CommentHubCommentsCounter'

interface CommentsCountProps extends BasicStyledComponent {
  containerId: string
  size?: 'small' | 'medium'
  /** No number while the count is unknown or zero (`CommentHubCommentsCounter`'s `hideZero`). */
  hideZero?: boolean
  /** A count the caller already knows (the article's conversation preview), drawn in place of
   *  the batched counter. */
  count?: number
}

const CommentsCount: React.FC<CommentsCountProps> = ({
  className,
  containerId,
  size = 'medium',
  hideZero,
  count,
}) => (
  <div
    className={clsx(styles.container, className, {
      [styles.sizeMedium]: size === 'medium',
      [styles.sizeSmall]: size === 'small',
    })}
  >
    <Comment className={styles.icon} />
    {count !== undefined ? (
      <div>{count}</div>
    ) : (
      <CommentHubCommentsCounter containerId={containerId} hideZero={hideZero} />
    )}
  </div>
)

export default CommentsCount
